'use client'

import { useEffect, useState } from 'react'
import { clsx } from 'clsx'
import { BaseHit, Hit } from 'instantsearch.js'
import { useLocale, useTranslations } from 'next-intl'
import { searchClient } from 'algolia/searchClient'
import { categoryKeyMap } from 'components/contentstack/utils/petCategory'
import { mapProduct } from 'helpers/algolia/map-product'
import { SupportedLocale, getIndex } from 'providers/algolia/localized-index/indexMap'
import { logError } from 'telemetry/client'
import PremiumTile from '../premium-tile'

export interface PremiumsSectionProps {
  category?: string
  maxItems?: number
  inAccount?: boolean
}
const PremiumsSection = ({ category, maxItems = 100, inAccount = false }: PremiumsSectionProps) => {
  const locale = useLocale()
  const t = useTranslations()
  const indexName = getIndex('products', locale as SupportedLocale)
  const [products, setProducts] = useState<Hit<BaseHit>[]>([])

  useEffect(() => {
    const fetchLoyaltyProducts = async () => {

      let filters = `isLoyaltyProduct:true`
      if(category){
        const categoryValue = categoryKeyMap[category] ?? category
        filters = `isLoyaltyProduct:true AND categoryKeys.${locale}:"${categoryValue}"`
      }

      try {
        const { results } = await searchClient.search<Hit<BaseHit>>([{
          indexName,
          params: {
            query: '',
            filters,
            hitsPerPage: maxItems,
          },
        }])

        if (results[0] && 'hits' in results[0]) {
          setProducts(results[0].hits)
        }
      } catch (error) {
        logError(error, { message: 'Error fetching loyalty products', meta: { component: 'premiums-section' } })
      }
    }

    fetchLoyaltyProducts()
  }, [indexName, category, locale, maxItems])

  if(products.length <= 0){
    return (
      <div className='flex gap-16'>
        <span>{t('account.no-premiums-available')}</span>
      </div>
    )
  }

  return (
    <div className='grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 lg:gap-24'>
      {products.map((product, k) => (
        inAccount
          ?  <PremiumTile
              key={product.objectID}
              product={mapProduct(product, locale)}
              classNames={clsx({
                'hidden md:flex': k === 1,
                'hidden lg:flex': k > 1,
              })}
            />
          : <PremiumTile
              key={product.objectID}
              product={mapProduct(product, locale)}
            />
      ))}
    </div>
  )
}

export default PremiumsSection
